import React from 'react'
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell } from 'semantic-ui-react'
import { filterOrdersByDate, getResellerOrders, getRevenue, getCost, numberWithCommas } from './utils'

const ResellerTables = ({ orders, resellers }) => {
    const filteredResellers = resellers.filter(r => !['Bianca', 'Emperor Admin', 'Nika', 'Winson Khai Quan'].includes(r.name))
    const ordersToday = filterOrdersByDate(orders, 24)
    const lifetimeOrders = filterOrdersByDate(orders, 1000000)

    const renderStatsRow = (reseller, orders) => {
        const resellerOrders = getResellerOrders(orders, reseller)
        const revenue = getRevenue(resellerOrders)
        const cost = getCost(resellerOrders)
        const profit = revenue - cost

        return (
            <TableRow key={reseller.name}>
                <TableCell><h4 style={{ color: 'white' }}>{reseller.name}</h4></TableCell>
                <TableCell>{numberWithCommas(resellerOrders.length)}</TableCell>
                <TableCell>${((revenue / resellerOrders.length) || 0).toFixed(2)}</TableCell>
                <TableCell style={{ color: '#90EE90' }}>${numberWithCommas(revenue.toFixed(2))}</TableCell>
                <TableCell style={{ color: '#FAA0A0' }}>${numberWithCommas(cost.toFixed(2))}</TableCell>
                <TableCell style={{ color: '#90EE90' }}>${numberWithCommas(profit.toFixed(2))}</TableCell>
                <TableCell>{((profit / revenue * 100) || 0).toFixed(2)}%</TableCell>
            </TableRow>
        )
    }

    return (
        <>
            <h2 style={{ color: 'white' }}>Resellers</h2>
            <Table size={window.innerWidth < 768 ? 'small' : null} celled unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap', marginTop: 20 } : { marginTop: 20 }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell textAlign="center" colSpan={filteredResellers.length}>Account Balance</TableHeaderCell>
                    </TableRow>
                    <TableRow>
                        {filteredResellers.map(reseller => (
                            <TableHeaderCell key={reseller.name}>{reseller.name}</TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        {filteredResellers.map(reseller => (
                            <TableCell key={reseller.name}><b>${reseller.balance.toFixed(2)}</b></TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
            <Table size={window.innerWidth < 768 ? 'small' : null} celled unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap', marginTop: 20 } : { marginTop: 20 }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell textAlign="center" colSpan="7">Lifetime (from 4 Apr 2025)</TableHeaderCell>
                    </TableRow>
                    <TableRow>
                        <TableHeaderCell width={3}></TableHeaderCell>
                        <TableHeaderCell>Orders</TableHeaderCell>
                        <TableHeaderCell width={2}>Average Order</TableHeaderCell>
                        <TableHeaderCell>Revenue</TableHeaderCell>
                        <TableHeaderCell>Cost</TableHeaderCell>
                        <TableHeaderCell>Profit</TableHeaderCell>
                        <TableHeaderCell>Margin</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {filteredResellers.map(reseller => renderStatsRow(reseller, lifetimeOrders))}
                </TableBody>
            </Table>
            <Table size={window.innerWidth < 768 ? 'small' : null} celled unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap', marginTop: 20 } : { marginTop: 20 }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell textAlign="center" colSpan="7">Past 24 Hours</TableHeaderCell>
                    </TableRow>
                    <TableRow>
                        <TableHeaderCell width={3}></TableHeaderCell>
                        <TableHeaderCell>Orders</TableHeaderCell>
                        <TableHeaderCell width={2}>Average Order</TableHeaderCell>
                        <TableHeaderCell>Revenue</TableHeaderCell>
                        <TableHeaderCell>Cost</TableHeaderCell>
                        <TableHeaderCell>Profit</TableHeaderCell>
                        <TableHeaderCell>Margin</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {filteredResellers.map(reseller => renderStatsRow(reseller, ordersToday))}
                </TableBody>
            </Table>
        </>
    )
}

export default ResellerTables